module.exports = __webpack_public_path__ + "frontend/img/icon_gender_other.c441125f.svg";